import { Item, ItemType } from '../../UI/Cube/types'
import olaf from '../../../assets/image/cube/tiles/01-Olaf.webp'
import fuerDich from '../../../assets/image/cube/tiles/03-FuerDich.webp'
import tinder from '../../../assets/image/cube/tiles/04-Tinder.webp'
import gewinnspiel from '../../../assets/image/cube/tiles/05-Gewinnspiel.webp'
import briefwahl from '../../../assets/image/cube/tiles/06-Briefwahl.webp'

const baseItems: [Item, Item, Item, Item, Item] = [
  {
    type: ItemType.IMAGE,
    src: olaf,
    //link: `${frontendDomain}/olafscholz`,
  },
  {
    type: ItemType.IMAGE,
    src: fuerDich,
    //link: `${frontendDomain}/programm`,
  },
  {
    type: ItemType.IMAGE,
    src: tinder,
    //link: 'https://deinewahl.spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
  },
  {
    type: ItemType.IMAGE,
    src: gewinnspiel,
    //link: `${frontendDomain}/gewinnspiel`,
  },
  {
    type: ItemType.IMAGE,
    src: briefwahl,
    //link: `${frontendDomain}/briefwahl`,
  },
]

export default baseItems
